import React from "react";
import { Text, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";
import { getAppState } from "../../../state";
import { ListInfoStyled } from "../styles/Styled";

const BuildInfo = () => {
  // This build info is a placeholder that gets updated in Jenkins once the app is built. This means locally the version
  // won't be displayed in the screen but only when the app is being served from a given environment (prod, stg, dev...)
  const buildInfo = getAppState().buildInfo;
  buildInfo.publicVersion = config.get().sdk.publicVersion;
  return (
    buildInfo && (
      <ListInfoStyled data={buildInfo} size="xsmall" color="greyDarkest" type="dl" display="inline" separator=":" />
    )
  );
};

export const ContactUs = () => {
  return (
    <>
      <Text text={i18n.get("pages.settings.contactUs.to")} />
      <Heading rank={2} text={i18n.get("pages.settings.contactUs.url")} />
      <BuildInfo />
    </>
  );
};
